import React, { useEffect, useState } from "react";
import {
  Spinner,
  TextField,
  Title,
  TextAreaInput,
  ActionButton,
} from "../../../components/atoms";
import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import ImageUploading from "react-images-uploading";
import { FaTimes, FaTrash } from "react-icons/fa";
import validator from "../../../utils/validations";
import { CustomerAddressRow, SideBackNav } from "../../../components/organisms";
import {
  UrlList,
  OrderItemListWithActions,
} from "../../../components/molecules";
import { PastOrderDetailRow } from "./PastOrderDetailRow";
import { useLocation } from "react-router";
import { REPORTORDERISSUE } from "../../../api/apiConfig";
import { apiPost, AnalyticsService, getOrderItems } from "../../../utils";
import reportIcon from "../../../assets/images/report-icon.svg";
import uploadIcon from "../../../assets/images/upload-icon.svg";
import { UPDATEPASTORDERPRODUCT } from "../../../api/apiConfig";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import {ConfirmationModal}  from "../../../components/molecules/ConfirmationModal/ConfirmationModal"

const FormData = require("form-data");

export const OrderDetailsComp = ({ onBack }) => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [orderData, setOrderData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [refundObject, setRefundObject] = useState(null);
  const [isRefundLoading, setIsRefundLoading] = useState(false);
  const { state } = useLocation();
  
  const [stateField, setStateField] = useState({
    typeValue: "",
    descValue: "",
    issueOrderNo: "",
    orderId: null,
    
  });
  console.log("state", state);
  const {
    orderId,
    customer,
    time,
    date,
    orderNumber,
    url,
    value,
    customerAddress,
    note,
    lineItems
  } = state;
  const { typeValue, descValue, issueOrderNo, lineItemId } = stateField;
  const updateState = (data) =>
    setStateField((prevState) => ({ ...prevState, ...data }));

  const [typeError, setTypeError] = useState("");
  const [descError, setDescError] = useState("");

  const changeTextValues = (e) => {
    updateState({ [e.target.name]: e.target.value });
  };
  const [image, setImage] = useState("");
  const onImageChange = (imageList) => {
    setImage(imageList);
    AnalyticsService.logEvent("IMAGE_UPLOADED");
  };

  const isValidData = () => {
    const typeError = validator({ typeValue });
    const descErr = validator({ descValue });

    if (typeError || descErr) {
      setTypeError(typeError);
      setDescError(descErr);
      AnalyticsService.logEvent("FIELDS_ERROR", {
        issueTypeError: typeError,
        issueDescriptionError: descErr,
      });
      return false;
    } else if (typeError) {
      setTypeError(typeError);
      setDescError("");
      AnalyticsService.logEvent("FIELDS_ERROR", {
        issueTypeError: typeError,
      });
      return false;
    } else if (descErr) {
      setDescError(descErr);
      setTypeError("");
      AnalyticsService.logEvent("FIELDS_ERROR", {
        issueDescriptionError: descErr,
      });
      return false;
    }
    setTypeError("");
    setDescError("");
    return true;
  };

  const onReportIssue = async (event) => {
    event.preventDefault();
    const checkValid = isValidData();
    if (checkValid) {
      const form = new FormData();
      form.append("OrderNo", issueOrderNo);
      form.append("OrderId", orderId);
      form.append("LineItemId", lineItemId);
      form.append("TypeOfIssue", event.target.typeValue.value);
      form.append("IssueDescription", event.target.descValue.value);
      form.append("Attachment", image.length > 0 ? image[0].file : undefined);
      apiPost(REPORTORDERISSUE, form, { "Content-Type": "multipart/form-data" })
        .then((response) => {
          
          if (response) {
            setOpen(false);
            AnalyticsService.logEvent("ORDER_ISSUE_REPORTED_SUCCESSFULLY", {
              orderNo: issueOrderNo,
              typeOfIssue: event.target.typeValue.value,
              issueDescription: event.target.descValue.value,
            });
            toast.success("Issue reported successfully");
              setTimeout(() => {
                navigate("/pastOrders");
              }, 1000);
            }
        })
        .catch((err) => {
          toast.error("Something went wrong!");
          AnalyticsService.logEvent("ORDER_ISSUE_REPORT_ERROR", {
            Error: err,
          });
          return null;
        });
    }
  };

  const orderValue = value.toLocaleString({ maximumFractionDigits: 2 });

  useEffect(async () => {
    setIsLoading(true);
    //const { itemsAndLinks: res, orderResponse } = await getOrderItems(orderId);
    setData(lineItems);
    
    //setOrderData(orderResponse);
    setIsLoading(false);
  }, []);

  const [open, setOpen] = useState(false);
  const onCloseModal = () => {
    AnalyticsService.logEvent("REPORT_ISSUE_MODAL_CLOSE");
    setOpen(false);
    updateState({
      typeValue: "",
      descValue: "",
    });
    setTypeError("");
    setDescError("");
    setImage("");
  };
  const onOpenModal = (item) => {
    if(!item.isConfirmReturn) return;
    AnalyticsService.logEvent("REPORT_ISSUE_MODAL_OPEN", {
      orderNo: item.orderNo,
    });
    setOpen(true);
    updateState({
      issueOrderNo: item.orderNo,
      orderId:item.orderId,
      typeValue: "",
      descValue: "",
      lineItemId: item.id,
    });
    setTypeError("");
    setDescError("");
    setImage("");
  };
 const handleLineItemRefund = async () =>{
 
  setIsRefundLoading(true);
  
  
                       try {
                        const res = await apiPost(UPDATEPASTORDERPRODUCT, { id:refundObject.id, orderId:refundObject.orderId });
                        if (res) {

                          toast.success("Return confirmed successfuly");
                              setTimeout(() => {
                                navigate("/pastOrders");
                              }, 1000);
                        }
                        else{
                          console.log(res);
                          toast.error("Refund failed!");
                        }
                      } catch (error) {
                        toast.error("Something went wrong!");
                      }

                        
                          setIsRefundLoading(false);
                          setOpenReturnModal(false);
                          setTimeout(() => {
                            navigate("/pastOrders");
                          }, 1000);
 };
 const handleCloseRefundModal = () =>{
  setOpenReturnModal(false);
 }
  const displayItems = () => {
    return (
      <div style={{width:'100%'}}>
        <div id="min-width-p">
          {data &&
            React.Children.toArray(
              data.map((item, index) => {
                const costValue = item.price.toLocaleString({
                  maximumFractionDigits: 2,
                });

                return (
                  <Stack direction={"row"}  spacing={2} 
                    className={
                      index !== data.length - 1
                        ? "item-container-border-bottom"
                        : "item-container"
                    }
                  >
                   
                    <OrderItemListWithActions
                      topText={"Item Name"}
                      urlTrue={item.title && item.productUrl ? true : false}
                      text={item.title || "N/A"}
                      url={item.productUrl || "N/A"}
                      key={item.price}
                      cost={costValue || "N/A"}
                      quantity={item.quantity || "N/A"}
                      onReportClick={() => onOpenModal(item)}
                      isConfirmReturn={item.isConfirmReturn}
                      onConfirmReturn={() => {

                        setOpenReturnModal(true);
                        console.log("orderId", data[index].orderId);
                        setRefundObject({id:data[index].id, orderId:data[index].orderId});
                        
                      }}
                    />
                  </Stack>
                );
              })
            )}
        </div>
        <div className="spinnerDivDetails">
          <Spinner color={"black"} loading={isLoading} size={40} />
        </div>
      </div>
    );
  };

  return (
    <div className="new-orders-screen">
      <div className="dashboard-content-post body" style={{marginLeft:'0px'}}>
       
        <SideBackNav
          title={"Back"}
          onClick={onBack}
          orderNumber={`Order ${orderNumber}`}
          statusTitle={"Past orders"}
          ifNotes
          notes={note}
          isView={note ? true : false}
        />
      </div>
      <div className="details-overlay">
        <div className="new-orders-container" id="details-screen-box">
          <div className="orders">
            <PastOrderDetailRow
              customerName={customer || "N/A"}
              time={time}
              orderDate={date}
              orderValue={orderValue}
              productUrl={url}
              orderRef={orderNumber}
            />
          </div>
        </div>
        <div className="top-space-details">
          <div className="new-orders-container" id="details-screen-box">
            <div className="orders">
              <CustomerAddressRow
                customerContactNo={customerAddress?.phone || "N/A"}
                address1={customerAddress?.address1 || "N/A"}
                address2={customerAddress?.address2 || "N/A"}
                postalCode={customerAddress?.zip || "N/A"}
                city={customerAddress?.city || "N/A"}
                country={customerAddress?.country || "N/A"}
              />
            </div>
          </div>
        </div>
        <div className="top-space-details">
          <div
            className="new-orders-container set-height"
            id="details-screen-box"
          >
            <div className="orders" id="align-column">
              {displayItems()}
              <Modal
                open={open}
                showCloseIcon={false}
                center
                onClose={onCloseModal}
                classNames={{
                  modal: "customModal",
                }}
              >
                <form onSubmit={onReportIssue} encType="multipart/form-data">
                  <div className="titleLayer">
                    <div className="modalTitle">
                      <img src={reportIcon} className="icon" />
                      <Title text={"Report Issue"} />
                    </div>
                    <div onClick={onCloseModal}>
                      <FaTimes
                        className="fa-times-cls"
                        onClick={onCloseModal}
                      />
                    </div>
                  </div>
                  <div className="bottomSpacing">
                    <Title text={"Type of issue"} className="fieldLabel" />
                    <TextField
                      placeholder={"Summarize the issue"}
                      className="reportInput"
                      value={typeValue}
                      onChange={changeTextValues}
                      name={"typeValue"}
                      isError={typeError}
                      errorText={typeError}
                      mainWrapCls={"reportTextFWrap"}
                    />
                  </div>
                  <div className="bottomSpacing">
                    <Title text={"Describe issue"} className="fieldLabel" />
                    <TextAreaInput
                      placeholder={
                        "The more information you include, the faster we can solve the problem."
                      }
                      className="reportTextAInput"
                      value={descValue}
                      onChange={changeTextValues}
                      name={"descValue"}
                      isError={descError}
                      errorText={descError}
                      mainWrapCls={"reportWrapCls"}
                    />
                  </div>
                  <div className="bottomSpacing">
                    <Title text={"Attachment"} className="fieldLabel" />
                    <ImageUploading
                      data-testid="file-uploader"
                      value={image}
                      onChange={onImageChange}
                      dataURLKey="data_url"
                      maxFileSize={10485760}
                      acceptType={["png", "jpg", "jpeg"]}
                      maxNumber={1}
                    >
                      {({
                        imageList,
                        onImageUpload,
                        onImageRemove,
                        errors,
                      }) => (
                        <>
                          {image.length === 0 ? (
                            <div onClick={onImageUpload} className="uploadDiv">
                              <img src={uploadIcon} className="iconUpload" />
                              <Title
                                text={"Upload file"}
                                className="fieldLabelUpload"
                              />
                            </div>
                          ) : null}
                          {imageList.map((image, index) => (
                            <div key={index} className="uploadDivItem">
                              <img
                                src={image["data_url"]}
                                alt=""
                                className="image-item"
                              />
                              <div className="image-item__btn-wrapper">
                                <FaTrash
                                  className="fa-trash-cls"
                                  onClick={() => onImageRemove(index)}
                                />
                              </div>
                            </div>
                          ))}
                          {errors && (
                            <>
                              {errors.acceptType && (
                                <span className="errorTexCls">
                                  Selected file type is not allowed.
                                </span>
                              )}
                              {errors.maxFileSize && (
                                <span className="errorTexCls">
                                  Selected file type exceeds 10 MB.
                                </span>
                              )}
                            </>
                          )}
                        </>
                      )}
                    </ImageUploading>
                  </div>
                  <div className="push-right">
                    <ActionButton text="REPORT" type="submit" />
                  </div>
                </form>
              </Modal>
              <ConfirmationModal
                isOpen={openReturnModal}
                title="Confirm Item Refund"
                onConfirm={handleLineItemRefund}
                content="Please confirm you want to refund the selected line item"
                subContent="Note: This action can't be undone"
                isLoading={isRefundLoading}
                setClose={handleCloseRefundModal}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
